'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './menu-editor.routes';

export class MenuEditorComponent {

  constructor($uibModal, SettingsService, dialogs, $scope, prompt, Config, $window) {
    'ngInject';
    this.$uibModal = $uibModal;
    this.dialogs = dialogs;
    this.SettingsService = SettingsService;
    this.$scope = $scope;
    this.prompt = prompt;
    this.$window = $window;

    this.pageTitle = (this.public) ? "Public Menu Editor" : "Menu Editor";

    this.defaultMenuPermission = Config.getPlatformConfig().getMenuDefaultPermission();

    let settingName = (this.public) ? "public-menu" : "menu";

    SettingsService.getByName({name: settingName}, setting => {
      this.setting = setting;
      this.menu = setting.data;
    });

    this.remove = function (scope) {

      var nodeData = scope.$modelValue;

      var info = nodeData.subMenu ? " and <strong>ALL its Sub-Menu entries</strong>?" : "?";

      var dlg = this.dialogs.confirm("Delete Menu Entry?", "Do you really want to delete the Menu Entry <strong>"+nodeData.title+"</strong>" + info);
      dlg.result.then(() => {
        scope.remove();
      }, () => {
        // Cancel
      });
    };

    this.toggle = function (scope) {
      scope.toggle();
    };

    this.moveLastToTheBeginning = function () {
      var a = this.menu.pop();
      this.menu.splice(0, 0, a);
    };

    this.newItem = _ => {
      //ask the user for a string
      prompt({
        title: 'Title for the new menu entry',
        message: 'What would you like to name it?',
        input: true,
        label: 'Title',
      }).then((title) => {
        this.menu.push({
          title: title
        });
      });
    };

    this.newSubItem = function (scope) {
      var nodeData = scope.$modelValue;

      //ask the user for a string
      prompt({
        title: 'Title for the new sub menu entry',
        message: 'What would you like to name it?',
        input: true,
        label: 'Title',
      }).then(function(title){

        let url = '';

        if (!nodeData.subMenu) {
          nodeData.subMenu = [];

          if (nodeData.url) {
            url = nodeData.url;
            delete nodeData.url;
          }
        }

        nodeData.subMenu.push({
          title: title,
          url: url
        });
      });
    };

    this.collapseAll = function () {
      this.$scope.$broadcast('angular-ui-tree:collapse-all');
    };

    this.expandAll = function () {
      this.$scope.$broadcast('angular-ui-tree:expand-all');
    };

  }

  getPermissionInfo(node) {
    if (this.public) {
      return '<span class="label label-success">Public</span>';
    }

    let permissions = node.permission;

    if (!permissions) {
      if (this.defaultMenuPermission) {
        return '<span class="label label-default">'+this.defaultMenuPermission+'</span>';
      } else {
        return '<span class="label label-danger">-</span>';
      }
    } else {
      let html = [];

      permissions.forEach(permission => {
        html.push('<span class="label label-warning">'+permission+'</span>')
      });
      
      return html.join('');
    }
  }

  openMenuEntryEditor(menuEntry) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      size: 'lg',
      component: 'menuEntryEdit',
      resolve: {
        config: function() {
          return {
            public: that.public,
            menuEntry: menuEntry
          }
        }
      }
    });

    modalInstance.result.then(
      function () {
       //todo: ddd

      },
      function () { /* cancel */ }
    );

  }

  save() {
    this.setting.data = this.slider;
    this.SettingsService.update({id: this.setting._id}, this.setting, _ => {
      this.dialogs.notify("Success","The menu has been updated successfully");
      //then:  this.$window.location.reload();
    }, err => {
      console.log('There has been an error.')
    });
  }
}

export default angular.module('conduu.menuEditor', [uiRouter])
  .config(routes)
  .component('menuEditor', {
    template: require('./menu-editor.html'),
    controller: MenuEditorComponent,
    controllerAs: 'ctrl',
    bindings: {
      public: '<'
    }
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/admin/menu/menu-editor.component.js